import { createAsyncThunk } from "@reduxjs/toolkit";
import { WarehouseAxios } from "api/WarehouseAxios";
import { API_ENDPOINT } from "helpers/Endpoints/endpoints";
import { FilterBuilder } from "helpers/ThunkHelper/FilterBuilder";

// Fetch In Stock Items (which acts as Details for a product group)
export const fetchInStockItems = createAsyncThunk(
  "inStockItems/fetchInStockItems",
  async ({
    product_id,
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    warehouse_id,
  }: {
    product_id: string; // The ID of the product group to fetch items for
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    warehouse_id: string;
  }) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page.toString());
      params.append("page_size", pageSize.toString());
      if (search) params.append("search", search);
      if (sort) {
        const orderingValue = order === "desc" ? `-${sort}` : sort;
        params.append("ordering", orderingValue);
      }

      const filterPayload = FilterBuilder(filters ?? []);
      const body = {
        filters: filterPayload,
      };

      // Calls POST /api/warehouse/in-stock/details/:product_id?warehouse_id={UUID}
      const response = await WarehouseAxios.post(
        `${API_ENDPOINT.WAREHOUSE.STOCK_OVERVIEW.IN_STOCK.DETAIL(
          product_id,
          warehouse_id
        )}&${params.toString()}`,
        body
      );

      return {
        data: response.data?.data || [],
        rowCount: response.data?.count || 0,
      };
    } catch (error: any) {
      throw new Error(
        error.response?.data?.message || "Failed to fetch in stock items"
      );
    }
  }
);

// Fetch Filter Dropdown for InStock Items
export const fetchInStockItemsFilterDropdown = createAsyncThunk(
  "inStockItems/fetchInStockItemsFilterDropdown",
  async (
    {
      warehouse_id,
      product_id,
      field,
    }: {
      warehouse_id: string;
      product_id: string;
      field: string;
    },
    { rejectWithValue }
  ) => {
    try {
      const response = await WarehouseAxios.get(
        API_ENDPOINT.WAREHOUSE.STOCK_OVERVIEW.IN_STOCK.DETAILS_DROPDOWN(
          field,
          warehouse_id,
          product_id
        )
      );
      return response.data;
    } catch (err: any) {
      return rejectWithValue(
        err.response?.data || "Failed to fetch dropdown data"
      );
    }
  }
);

